import React, { useMemo } from "react";
import ReportViewer from "./components/ReportViewer";
import { generateStandardReportPdf } from "./utils/reportPdfGenerators";
import moment from "moment";

export default function DailySalesReport() {
  const formatDateTime = (value) => {
    if (!value) return "-";
    const m = moment(value, [moment.ISO_8601, "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD", "DD/MM/YYYY", "DD/MM/YYYY HH:mm:ss"], true);
    return m.isValid() ? m.format("DD/MM/YYYY hh:mm A") : String(value);
  };

  const columns = useMemo(
    () => [
      { name: "Date", selector: (r) => formatDateTime(r.SalesDay || r.Date) },
      { name: "Units", selector: (r) => r.UnitsSold ?? r.Units ?? 0 },
      { name: "Total Amount", selector: (r) => r.TotalAmount ?? r.Amount ?? 0 },
    ],
    []
  );

  return (
    <ReportViewer
      reportKey="dailySales"
      title="Daily Sales"
      columns={columns}
      fetchConfig={{
        url: "/reports/app2/daily-sales",
        paramsBuilder: (filters) => ({
          fromDate: filters.fromDate,
          toDate: filters.toDate,
        }),
      }}
      buildKpis={(rows) => {
        const units = (rows || []).reduce((a, r) => a + Number(r?.UnitsSold ?? r?.Units ?? 0), 0);
        const amt = (rows || []).reduce((a, r) => a + Number(r?.TotalAmount ?? r?.Amount ?? 0), 0);
        return [
          { label: "Units", value: units },
          { label: "Amount", value: amt.toLocaleString("en-IN") },
        ];
      }}
      pdfGenerator={generateStandardReportPdf}
    />
  );
}

